module.exports = __webpack_public_path__ + "ad2c047f8784bb2aaac410e0d8f4c641.MP3";